<div class="container-fluid">
  <div class="row d-flex">
    <div class="col">
      <img class="img-fluid" [src]="authService.appConfig.logo">
    </div>
    <div class="col-auto text-end" *ngIf="isUserActive">
      <dx-user-detail *ngIf="authService.user"></dx-user-detail>
    </div>
  </div>
  <section class="mfa-banner" role="region" aria-label="Multi-Factor Authentication Announcement">
    <div class="mfa-banner__inner">
      <span class="mfa-banner__important">Important:</span>
      WR Berkley is implementing Multi‑Factor Authentication.
      Enrollment will begin on <strong>March 3, 2026</strong>.
      Please see
      <a class="mfa-banner__link" href="/assets/images/MFA Auth0 Registration User Guide.v2.pdf" target="_blank"
        rel="noopener">user guide</a>
      for more information.
    </div>
  </section>
  <dx-app-navbar *ngIf="authService.hasAccess && isUserActive"></dx-app-navbar>
  <dx-app-auth-error *ngIf="!authService.hasAccess"></dx-app-auth-error>
</div>`